<template>
  <el-dialog title="Configurar E-mail de Campanha da Imobiliária" :visible.sync="isVisible" @open="open" :before-close="fechar" :close-on-click-modal="false" append-to-body v-loading="isLoading" width="50%">
    <el-form size="small" label-position="top" hide-required-asterisk	:show-message="false">
      
      <el-row>
        <el-col>
          <el-form-item label="Assunto da Campanha">
            <el-input v-model="form.assunto" :rows="1" type="textarea"  style="margin-top: 5px" />
          </el-form-item>
        </el-col>
      </el-row>
      <el-row>
        <el-col>
          <el-form-item label="Corpo">
            <el-input v-model="form.corpo" :autosize="{minRows: 6, maxRows: 10}" type="textarea"  style="margin-top: 5px" />
          </el-form-item>
        </el-col>
      </el-row>

      <el-row>
        <!--TABELA ALUGUEIS SELECIONADOS-->
        <el-col style="height: 100%; padding: 0px;">
          <el-row style="height: 100%; padding-top: 5px;">
            <el-col :md="24" :lg="24" style="height: 100%;">
              <el-form-item label="Imagens" style="width: 100%;">
                <el-table 
                :data="form.imagens"
                empty-text="Nenhuma imagem adicionada"
                height="150px"
                size="small"
                style="background-color: #FFFFFF; margin-top: 5px; border: solid 1px #DBDFE5; border-radius: 5px; padding: 5px 5px 5px 5px;"
                highlight-current-row
                :show-header="false">
                  <el-table-column min-width="auto" show-overflow-tooltip>
                    <template slot-scope="scope" >
                      <el-link type="success" @click="handleClickLinkImagem(scope.row.path)">
                        {{ scope.row.nomeArquivo }}
                      </el-link>       
                    </template>                                      
                  </el-table-column>
                  <el-table-column width="60px" column-key="acoes" align="right" header-align="rigth">
                    <template slot-scope="scope">
                      <el-button
                       type="text" 
                       size="small" 
                       style="padding: 0px;"
                       @click="removerImagemHandler(scope.row)">
                        <el-tooltip content="Remover imagem">
                          <i class="el-icon-delete" style="color: #F56C6C;"></i>
                        </el-tooltip>
                      </el-button>
                    </template>
                  </el-table-column>
                  <el-table-column width="30px" header-align="right" align="right"></el-table-column>
                </el-table>
              </el-form-item>
            </el-col>
          </el-row>
          <el-row style="text-align: start; padding-top: 10px">
            <el-col><el-button :disabled="isDisabledButtonAlterarImagem" @click="handleClickButtonAdicionarImagem" round type="primary" size="small">Adicionar</el-button></el-col>
          </el-row>
        </el-col>  
        </el-row>  


      <!-- <el-row>
        <el-col>
          <el-link :disabled="isDisabledLinkImagem" type="warning" @click="handleClickLinkImagemProprietario">
            <i class="el-icon-picture" />
            Imagem da Campanha
          </el-link>

          <el-button :disabled="isDisabledButtonAlterarImagem" @click="handleClickButtonAdicionarImagem" type="text" style="margin-left: 10px">
            <i class="el-icon-edit" />
            Alterar
          </el-button>
        </el-col>
      </el-row> -->
    </el-form>

    <span slot="footer">
      <el-button type="success" size="small" @click="handleClickButtonConcluir" round class="btn-box-shadow">
        <i class="el-icon-check" />
        Concluir
      </el-button>
    </span>

    <dialog-upload-imagem :isVisible="isVisibleDialogUploadImagem" @upload="uploadImagem" :parametros="form" @close="fecharDialogUploadImagem" />
  </el-dialog>
</template>

<script>
import DialogUploadImagem from './UploadImagemCampanhaDialog';
import { mapActions, mapState } from 'vuex';
import axios from 'axios';
import URLS from '../../../util/urls';

const baseForm = {
  corpo: '',
  assunto: '',
  id: 0,
  imagens: []
};
const baseUrlImagem = '';

export default {
  props: {
    isVisible: {
      type: Boolean,
      required: true,
    },
  },

  components: {
    DialogUploadImagem,
  },

  data() {
    return {
      form: { ...baseForm },

      urlImagem: baseUrlImagem,

      isDisabledButtonAlterarImagem: false,

      isVisibleDialogUploadImagem: false,
    };
  },

  computed: {
    ...mapState({
      isLoading(state) { return state.loading },
    }),

    hasImagemProprietario() {
      return this.urlImagem !== baseUrlImagem;
    },

    isDisabledLinkImagem() {
      return !this.hasImagemProprietario;
    },
  },

  methods: {
    ...mapActions([
      'showLoading',
      'hideLoading',
    ]),
    ...mapActions('loginStore', [
      'relogar',
    ]),

    open() {
      this.reset();
      this.recuperarParametros();
    },

    recuperarParametros() {
      this.showLoading();

      this.recuperar()
        .then(this.handleResultRecuperar)
        .catch(() => {
          this.$message.error("Não foi possível conectar-se ao servidor");
        })
        .finally(() => {
          this.hideLoading();
        });
    },
    handleResultRecuperar(result) {
      switch (result.status) {
        case 'SUCESSO':
          this.setForm(result.item);
          //this.setUrlImagens(result.item.imagens);
          break;

        case 'FALHA':
          this.disableButtonAlterarImagemProprietario();
          this.disableButtonAlterarImagemLocatario();
          break;
      
        case 'ERRO':
          this.$message.error("Não foi possível recuperar os parâmetros");
          break;
      }
    },

    recuperar() {
      return axios.post(URLS.IMOBILIARIAS_RECUPERAR_PARAMETROS_EMAIL_CAMPANHA)
        .then(response => {
          switch (response.data.status) {
            case 'SESSAO_EXPIRADA':
              return this.relogar().then(authResponse => {
                if(authResponse.status === 'SUCESSO') {
                  return this.recuperar();
                }
              });
          
            default:
              return response.data;
          }
        })
        .catch(error => {
          throw error;
        });
    },

    setForm(parametros) {
      this.form.corpo = parametros.corpo;
      this.form.assunto = parametros.assunto;
      this.form.id = parametros.id
      this.form.imagens = parametros.imagens
    },

    setUrlImagem(url) {
      if(url !== null) this.urlImagemProprietario = url;
    },

    handleClickLinkImagem(link) {
      this.openNewTab(link);
    },

    handleClickButtonConcluir() {
      this.gravar();
    },

    gravar() {
      const payload = {
        corpo: this.form.corpo.trim(),
        assunto: this.form.assunto.trim(),
        id: this.form.id
      }
      this.showLoading();

      this.gravarParametros(payload)
        .then(this.handleResultGravar)
        .catch(() => {
          this.$message.error("Não foi possível conectar-se ao servidor");
        })
        .finally(() => {
          this.hideLoading();
        });
    },

    handleResultGravar(result) {
      switch (result.status) {
        case 'SUCESSO':
          this.$message.success(result.mensagem);
          this.setForm(result.item);
          break;
      
        case 'ERRO':
          this.$message.error(result.mensagem);
          break;
      }
    },

    gravarParametros(payload) {
      return axios.post(URLS.IMOBILIARIAS_GRAVAR_PARAMETROS_EMAIL_CAMPANHA, payload)
        .then(response => {
          switch (response.data.status) {
            case 'SESSAO_EXPIRADA':
              return this.relogar().then(authResponse => {
                if(authResponse.status === 'SUCESSO') {
                  return this.gravarParametros(payload);
                }
              });
          
            default:
              return response.data;
          }
        })
        .catch(error => {
          throw error;
        });
    },

    removerImagemHandler(row){
      this.$confirm("Deseja remover a imagem?", "Atenção", {
        confirmButtonText: "Sim",
        cancelButtonText: "Não",
        type: "warning"
      }).then(() => {
        this.removerImagem(row);
      });
    },

    removerImagem(imagem) {
      let payload = {
        id: imagem.id
      }
      this.showLoading();
      return axios.post(URLS.IMOBILIARIAS_REMOVER_IMAGEM_EMAIL_CAMPANHA, payload)
        .then(response => {
          switch (response.data.status) {
            case 'SUCESSO':
              this.$message.success(response.data.mensagem)
              this.open()
              break
            case 'SESSAO_EXPIRADA':
              return this.relogar().then(authResponse => {
                if(authResponse.status === 'SUCESSO') {
                  return this.removerImagem();
                }
              });
            case 'ERRO':
              this.$message.error(response.data.mensagem);
              break;
            default:
              return response.data;
          }
        })
        .catch(() => {
          this.$message.error('Não foi possível conectar-se ao servidor');
        })
        .finally(() => {
          this.hideLoading();
        });
    },

    uploadImagem(urlImagem) {
      this.setUrlImagem(urlImagem);
      this.fecharDialogUploadImagem();
    },

    handleClickButtonAdicionarImagem() {
      this.exibirDialogUploadImagem();
    },

    exibirDialogUploadImagem() {
      this.isVisibleDialogUploadImagem = true;
    },
    fecharDialogUploadImagem() {
      this.isVisibleDialogUploadImagem = false;
      this.open();
    },
    enableButtonAlterarImagem() {
      this.isDisabledButtonAlterarImagem = false;
    },
    disableButtonAlterarImagem() {
      this.isDisabledButtonAlterarImagem = true;
    },

    openNewTab(url) {
      window.open(url, '_blank');
    },

    fechar() {
      this.$emit('close');
    },

    reset() {
      this.form = { ...baseForm };

      this.urlImagem = baseUrlImagem;

      this.isDisabledButtonAlterarImagem = false;
    },
  },
}
</script>
<style scoped>
.el-table__header-wrapper{
  display: none !important;
}
</style>